const loadingClass = 'btn--loading';

export const toggleLoadingState = (button, activate = true) => {
	button && button.classList.toggle(loadingClass, activate);
};
